import { useMutation } from '@apollo/client';
import { gql } from '@/__generated__';

const SetUsername = gql(`
  mutation SetUsername($username: String!) {
    setUsername(username: $username) {
      id
      username
    }
  }
`);

export const useSetUsername = () => {
  const [setUsernameMutation, result] = useMutation(SetUsername);

  const setUsername = (username: string) => {
    return setUsernameMutation({
      variables: { username },
    });
  };

  return [setUsername, result] as const;
};
